/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import useUserConfig from "../../../hooks/useUserConfig";

import Styles from "../UserRoleManagement/style";
import EmptyFileIcon from "../../../assets/svg/EmptyFile";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import User from "../../../services/api/user";
import ManagePermissionTable from "./PermissionTable";
import PermissionModal from "../../../components/common/new/Modals/UserPermissionModals/PermissionModal";

function PermissionManagement(values) {
  const [searchData, setSearchData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const hasPermission = useUserConfig();

  // const onModalToggle = () => setOpenModal((prev) => !prev);

  const fetchPermissions = async () => {
    try {
      setIsLoading(true);
      const result = await User.getRole();
      console.log("DATA :", result);

      // Showing some delay to avoid loader flicker issue

      setSearchData(result.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      Sentry.captureException(error);
    }
  };

  console.log("Permissions :", selectedRole);

  useEffect(() => {
    fetchPermissions();
  }, []);

  //   const onSelectMemberForTransfer = (member) => {
  //     dispatch({
  //       type: SET_SELECTED_MEMBER_TRANSFER,
  //       payload: member,
  //     });
  //     navigate(ROUTES.MEMBER_TRANSFER_REQUEST.path);
  //   };

  const onView = (row) => {
    setSelectedRole(row);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  return (
    <div style={Styles.container}>
      <div style={Styles.main}>
        {searchData?.length ? (
          <ManagePermissionTable
            searchData={searchData}
            onView={onView}
            hasPermission={hasPermission}
            // onMemberStatusToggle={onMemberStatusToggle}
          />
        ) : (
          <div style={Styles.initialContent}>
            <EmptyFileIcon width={100} />
            <span style={Styles.text}>No data found</span>
          </div>
        )}
      </div>
      {isLoading && <Loader />}
      <Modal open={openModal} onClose={closeModal} title="Permission">
        <PermissionModal
          open={openModal}
          roles={selectedRole}
          onClose={closeModal}
          values={values}
        />
      </Modal>
    </div>
  );
}

export default PermissionManagement;
